import { createSlice } from "@reduxjs/toolkit";
import { Circuit, Configuration, TrackMap } from "../types/trackMap";

const emptyTrackMap: TrackMap = {
  circuitName: null,
  configurationName: null,
  circuitID: null,
  configurationID: null,
  trackEdges: {
    inner: { lat: [], lon: [] },
    outer: { lat: [], lon: [] },
  },
  lines: [],
  turnMarkings: [],
  loopMarkings: [],
  attackMarkings: [],
  sectors: [],
};

const initialState = {
  trackMap: emptyTrackMap,
  trackMapPreview: emptyTrackMap,
  availableCircuits: [] as Circuit[],
  availableConfigurationsForCircuit: [] as Configuration[],
  selectedCircuit: null as Circuit | null,
  selectedConfiguration: null as Configuration | null,
};

export const trackMapSlice = createSlice({
  name: "trackMap",
  initialState,
  reducers: {
    setTrackMap: (state, action) => {
      state.trackMap = action.payload;
      state.trackMapPreview = action.payload;
      state.selectedCircuit = {
        fullName: action.payload.circuitName || "",
        globalUniqueId: action.payload.circuitID || "",
      };
      state.selectedConfiguration = {
        name: action.payload.configurationName || "",
        globalUniqueId: action.payload.configurationID || "",
      };
    },
    setTrackMapPreview: (state, action) => {
      state.trackMapPreview = action.payload;
      state.selectedCircuit = {
        fullName: action.payload.circuitName || "",
        globalUniqueId: action.payload.circuitID || "",
      };
      state.selectedConfiguration = {
        name: action.payload.configurationName || "",
        globalUniqueId: action.payload.configurationID || "",
      };
    },
    setAvailableCircuits: (state, action) => {
      state.availableCircuits = action.payload;
    },
    setAvailableConfigurationsForCircuit: (state, action) => {
      state.availableConfigurationsForCircuit = action.payload;
    },
    setSelectedCircuit: (state, action) => {
      state.selectedCircuit = action.payload;
      state.selectedConfiguration = null;
      state.trackMapPreview = emptyTrackMap;
      state.availableConfigurationsForCircuit = [];
    },
    setSelectedConfiguration: (state, action) => {
      state.selectedConfiguration = action.payload;
    },
  },
});

export const {
  setTrackMap,
  setTrackMapPreview,
  setAvailableCircuits,
  setAvailableConfigurationsForCircuit,
  setSelectedCircuit,
  setSelectedConfiguration,
} = trackMapSlice.actions;
export default trackMapSlice.reducer;
